import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormLabel,
  Select,
  Spinner,
} from "@chakra-ui/react";

const ClockSelect = ({
  label = "Clock",
  value,
  onChange,
  size = "md",
  height = undefined,
}) => {
  const [clocks, setClocks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClocks = async () => {
      try {
        const res = await fetch("https://clock.poc.mrc.ai/api/clocks");
        const json = await res.json();
        if (Array.isArray(json)) {
          const sorted = [...json].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "")
          );
          setClocks(sorted);
        } else {
          console.error("Unexpected clock data format", json);
        }
      } catch (err) {
        console.error("Failed to fetch clocks", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClocks();
  }, []);

  const handleChange = (e) => {
    const selectedId = e.target.value;
    onChange(selectedId); // just return the _id
  };

  return (
    <FormControl>
      {label && <FormLabel fontSize={size}>{label}</FormLabel>}
      {loading ? (
        <Spinner />
      ) : (
        <Select
          placeholder="Select Clock..."
          value={value || ""}
          onChange={handleChange}
          size={size}
          height={height}
        >
          {clocks.map((clock) => (
            <option key={clock._id} value={clock._id}>
              {clock.name} ({clock.type})
            </option>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default ClockSelect;
